import { render } from "./ConfigQuestionSetScreen.vue?vue&type=template&id=329ba4b1"
import script from "./ConfigQuestionSetScreen.vue?vue&type=script&lang=ts"
export * from "./ConfigQuestionSetScreen.vue?vue&type=script&lang=ts"
script.render = render

export default script